document.addEventListener("DOMContentLoaded", function () {
  const cardContainer = document.querySelector(".ck_card-container");
  const cards = Array.from(cardContainer.querySelectorAll(".ck_card"));
  // Define the desired order of the cards
  const cardOrder = [
    "3D Art",
    "Fruity Friendships",
    "Paintings",
    "Depth of a Sketch",
    "Reality’s Fugue Booths",
    "Mermaid AR project",
    "13th Lake Map",
    "Desk Project",
    "empty 1", //empty card
    "Instagram",
    "Photography",
    "T-shirt Buy",
    "Print Buy",
    "empty 2", //empty card
    "Digital",
    "last"
  ];
  // Function to reorder the cards
  function orderCards() {
    cardOrder.forEach((name) => {
      const cardToMove = cards.find((card) => card.dataset.cardName === name);
      if (cardToMove) {
        cardContainer.appendChild(cardToMove);
      }
    });
  }
  orderCards(); // Initial ordering when the page loads

  // Function to handle floating image display
  function updateFloatingImage() {
    const emptyCard = document.querySelector(".ck_card-empty");
    const imagePath = emptyCard.dataset.floatingImage;

    // Remove any existing image
    const existingImage = emptyCard.querySelector("img");
    if (existingImage) {
      existingImage.remove();
    }

    if (imagePath) {
      const img = document.createElement("img");
      img.src = imagePath;
      img.classList.add("ck_floating-image");
      emptyCard.appendChild(img);
    }
  }

  // Example of how you might trigger the image to appear (you'll need to adapt this)
  // For instance, you could have a button or a timer that updates the data-floating-image attribute
  setTimeout(() => {
    const emptyCard = document.querySelector(".ck_card-empty");
    emptyCard.dataset.floatingImage =
      "https://cdn.shopify.com/s/files/1/0580/9419/0772/files/your_floating_image.png?v=12345"; // Replace with your image URL
    updateFloatingImage();
  }, 5000); // Show the image after 5 seconds (for example)

  // You'll likely want a way to control when the image appears and disappears
  // You could add another setTimeout to clear the image source, or trigger it based on user interaction.
});
